module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-premium-078aaa2ccd905fc8fc001b5cf159fbb4.webp";